<template>
	<v-snackbar color="gradiente" v-model="value" vertical bottom>
		{{ text }}
		<v-btn dark flat @click="close">{{ buttonText }}</v-btn>
	</v-snackbar>
</template>

<script>
	export default {
		props: ["value", "text", "buttonText"],

		methods: {
			close() {
				this.$emit("input", !this.value);
			}
		}
	};
</script>

<style>
</style>
